import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: {
    showDialog: Boolean,
    checkedNodes: {
      // 选中的节点
      type: Array,
      default: function _default() {
        return [];
      }
    },
    areaGroupId: {
      type: String || Number,
      default: ''
    }
  },
  data: function data() {
    return {
      checkButton: '空置',
      buttons: ['空置', '已租'],
      defaultProps: {
        children: 'pmsTree',
        label: 'name'
      },
      treeQuery: {
        flag: '9',
        areaGroupId: '',
        resourceType: 1,
        houseStatus: 2
      },
      treeData: [],
      detialList: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.loadMenuTree();
    },
    loadMenuTree: function loadMenuTree() {
      var _this = this;

      // 加载树
      this.treeQuery.areaGroupId = this.areaGroupId;
      fetchTreeList(this.treeQuery).then(function (response) {
        _this.checkedId = 0;
        _this.treeData = response.data.data;

        _this.treeFormat(_this.treeData);

        if (_this.checkedNodes.length > 0) _this.$refs.tree.setCheckedKeys(_this.checkedNodes);
      });
    },
    handleRadioChange: function handleRadioChange(val) {
      this.treeQuery.houseStatus = val === '已租' ? 1 : 2;
      this.loadMenuTree();
    },
    treeFormat: function treeFormat(list) {
      var _this2 = this;

      list.forEach(function (item) {
        _this2.treeChildFormat(item);

        if (item.pmsTree && item.pmsTree.length > 0) {
          _this2.treeFormat(item.pmsTree);
        }
      });
    },
    treeChildFormat: function treeChildFormat(child) {
      child.checkedId = ++this.checkedId;
    },
    checkChange: function checkChange() {
      var checkedTreeNodes = this.$refs.tree.getCheckedNodes();
      var filterData = checkedTreeNodes.filter(function (item) {
        return item.flag === '211';
      });
      this.detialList = filterData.map(function (item) {
        return {
          resourceId: item.id,
          flag: item.flag
        };
      });
    },
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      if (data.flag === '0') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanliquyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '1') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fenzu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '2') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'louyu'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '21') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'danyuan'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '211') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'fangjian'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '212') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'guanggaowei'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '3') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'cheku'
          }
        }), h("span", [node.label])]);
      } else if (data.flag === '31') {
        return h("span", {
          "class": 'custom-tree-node'
        }, [h("svg-icon", {
          "attrs": {
            "class-name": 'international-icon',
            "icon-class": 'chewei'
          }
        }), h("span", [node.label])]);
      }
    },
    handCreate: function handCreate() {
      if (this.detialList && this.detialList.length > 0) {
        this.$emit('handCancle', true);
        this.$emit('sendHouseData', this.detialList);
      } else {
        this.$message.error('请选择需要租赁的房间');
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};